// removed by extract-text-webpack-plugin
module.exports = {"root":"_3PafYrP","work":"_3qs6VhE","colon":"_2g5E9UJ","workType":"_1jIlD-0","root_hasOneSelected":"o73nQvw","count":"_34n4l2n"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Search/components/RefineBar/components/WorkTypeSummary/WorkTypeSummary.less
 ** module id = 913
 ** module chunks = 0
 **/